/** Un tronson, desenat ca plan — la frontul nominal.
 *
 *  E DOAR ÎNVELIȘUL. Desenul propriu-zis e `Desen.tsx`, același pe care îl
 *  folosește editorul, iar panoramarea și mărirea vin din `Panza2D.tsx`, adică
 *  din același model ca vizualizatorul de arhitectură (rotița mărește, W/A/S/D
 *  și săgețile mută, `0` reîncadrează).
 *
 *  Erau două desene ale aceluiași lucru și au apucat să difere înainte să apuce
 *  cineva să le compare: aici golurile erau desenate cu `pointerEvents="none"`,
 *  deci nu se putea da click pe nicio ușă, în timp ce în editor se putea. De-aia
 *  e unul singur acum.
 */
import { useMemo, useRef } from "react";
import { deriva, type TronsonDoc } from "./doc";
import Desen, { type Ales } from "./Desen";
import { BaraZoom, useGesturi, useIncadrare } from "./Panza2D";
import { trasee } from "./design/electric";
import { axeleZidurilor } from "./editor/model";

export type { Ales };

export default function TronsonView({ doc, ales, laAles, mod = "plan" }: {
  doc: TronsonDoc;
  ales: Ales;
  laAles: (a: Ales) => void;
  /** «plan» sau «design» — v. nota din `Desen`. */
  mod?: "plan" | "design";
}) {
  const gazda = useRef<HTMLDivElement>(null);
  const plan = useMemo(() => deriva(doc), [doc]);
  /** Traseele firelor. Numai în design, și o singură dată pe document: e un
   *  Dijkstra pe graful pereților, nu o socoteală de refăcut la fiecare
   *  panoramare. */
  const firele = useMemo(() => (mod !== "design" ? []
    : trasee(plan.electrice, axeleZidurilor(doc), plan.nivel)), [mod, plan, doc]);
  const { view, setView, incadreaza } = useIncadrare(plan, gazda, doc.id);
  // În vizualizator butonul stâng pe fond panoramează: n-are ce altceva să facă.
  const { panoramaPornita, spatiu } = useGesturi({
    gazda, view, setView, dim: { w: 0, h: 0 }, incadreaza, poatePanorama: true,
  });

  return (
    <div className="ob-tr-panza2d" ref={gazda}>
      <svg width="100%" height="100%"
           onPointerDown={(e) => { if (!panoramaPornita(e)) laAles(null); }}
           onContextMenu={(e) => e.preventDefault()}>
        {view && (
          <g transform={`translate(${view.tx} ${view.ty}) scale(${view.k})`}>
            {/* FĂRĂ comutare de uși aici. Deschis/închis și sensul de
                deschidere stau în DOCUMENT de-acum, iar vizualizatorul n-are
                cale de scriere: un comutator care ar arăta altceva decât ce se
                salvează ar fi mai rău decât lipsa lui. Se schimbă din editor. */}
            <Desen plan={plan} ales={ales} pxPerM={view.k} mod={mod}
                   trasee={firele} laAles={(a) => laAles(a)}
                   panorameaza={spatiu} />
          </g>
        )}
      </svg>
      <BaraZoom view={view} setView={setView} incadreaza={incadreaza} />
    </div>
  );
}
